import SubLinks from '@/components/list-links/sublinks-class.js';

document.querySelectorAll('.js-list-links__arrow').forEach(elem=>new SubLinks(elem));